import { searchNav } from '/app/app/assets/js/mixins/search_nav.js'

export default searchNav
